'use client';

import { useId, useState } from 'react';
import { classNames } from '../../utils/classNames';

interface TooltipProps {
  text: string;
  children: React.ReactNode;
  className?: string;
}

export function Tooltip({ text, children, className }: TooltipProps) {
  const [open, setOpen] = useState(false);
  const tooltipId = useId();

  return (
    <span
      className={classNames('relative inline-flex items-center', className)}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
    >
      <span
        tabIndex={0}
        role="button"
        aria-label="More info"
        aria-describedby={open ? tooltipId : undefined}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((prev) => !prev);
        }}
        onKeyDown={(e) => {
          if (e.key === ' ') e.preventDefault();
          if (e.key === 'Enter' || e.key === ' ') setOpen((prev) => !prev);
        }}
      >
        {children}
      </span>
      {open && (
        <span
          id={tooltipId}
          role="tooltip"
          className="absolute z-10 w-48 px-3 py-2 mb-2 tra-text-web-body-m text-white normal-case -translate-x-1/2 rounded shadow-lg bottom-full left-1/2 bg-neutral-700"
        >
          {text}
          <span className="absolute -translate-x-1/2 border-4 border-transparent left-1/2 top-full border-t-neutral-700" />
        </span>
      )}
    </span>
  );
}
